/* Big Wedge — round importer: pure logic shared by the page script and the tests. No DOM in here. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) { module.exports = factory(); }
  else { root.BwImporterCore = factory(); }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function isRealDate(iso) {
    if (typeof iso !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return false;
    var y = +iso.slice(0, 4), m = +iso.slice(5, 7), d = +iso.slice(8, 10);
    if (y < 1900 || y > 2100 || m < 1 || m > 12 || d < 1) return false;
    var leap = (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;
    var days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return d <= days[m - 1];
  }

  function formatDate(iso) {
    if (!isRealDate(iso)) return '';
    return (+iso.slice(8, 10)) + ' ' + MONTHS[+iso.slice(5, 7) - 1] + ' ' + iso.slice(0, 4);
  }

  var COUNTRIES = ["Afghanistan","Åland Islands","Albania","Algeria","American Samoa","Andorra","Angola","Anguilla","Antarctica","Antigua & Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia & Herzegovina","Botswana","Bouvet Island","Brazil","British Indian Ocean Territory","British Virgin Islands","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Caribbean Netherlands","Cayman Islands","Central African Republic","Chad","Chile","China","Christmas Island","Cocos (Keeling) Islands","Colombia","Comoros","Congo (DRC)","Congo (Republic)","Cook Islands","Costa Rica","Côte d'Ivoire","Croatia","Cuba","Curaçao","Cyprus","Czechia","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia","Falkland Islands","Faroe Islands","Fiji","Finland","France","French Guiana","French Polynesia","French Southern Territories","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau","Guyana","Haiti","Heard & McDonald Islands","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macao","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar (Burma)","Namibia","Nauru","Nepal","Netherlands","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Niue","Norfolk Island","North Korea","North Macedonia","Northern Mariana Islands","Norway","Oman","Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Pitcairn Islands","Poland","Portugal","Puerto Rico","Qatar","Réunion","Romania","Russia","Rwanda","Samoa","San Marino","São Tomé & Príncipe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Sint Maarten","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia & South Sandwich Islands","South Korea","South Sudan","Spain","Sri Lanka","St. Barthélemy","St. Helena","St. Kitts & Nevis","St. Lucia","St. Martin","St. Pierre & Miquelon","St. Vincent & Grenadines","Sudan","Suriname","Svalbard & Jan Mayen","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tokelau","Tonga","Trinidad & Tobago","Tunisia","Türkiye","Turkmenistan","Turks & Caicos Islands","Tuvalu","U.S. Outlying Islands","U.S. Virgin Islands","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan","Vanuatu","Vatican City","Venezuela","Vietnam","Wallis & Futuna","Western Sahara","Yemen","Zambia","Zimbabwe"];
  function isCountry(v) { return typeof v === 'string' && COUNTRIES.indexOf(v) !== -1; }

  function isWhole(n) { return typeof n === 'number' && isFinite(n) && Math.floor(n) === n; }

  function validateRound(r) {
    var errors = {};
    r = r || {};
    if (typeof r.course_name !== 'string' || !r.course_name.trim()) errors.course_name = 'Enter the course name.';
    if (!isCountry(r.country)) errors.country = 'Choose the country.';
    if (!isRealDate(r.round_date)) errors.round_date = 'Enter the date the round was played.';
    if (!isWhole(r.round_total) || r.round_total < 1 || r.round_total > 300) errors.round_total = 'Enter the final score as a whole number.';
    if (r.holes_played !== 9 && r.holes_played !== 18) errors.holes_played = 'Choose 9 or 18 holes.';
    return { ok: Object.keys(errors).length === 0, errors: errors };
  }

  function buildImportData(rounds) {
    var out = [];
    for (var i = 0; i < rounds.length; i++) {
      var r = rounds[i];
      if (!validateRound(r).ok) throw new Error('Round ' + (i + 1) + ' is incomplete.');
      out.push({ course_name: r.course_name.trim(), country: r.country, round_date: r.round_date, round_total: r.round_total, holes_played: r.holes_played });
    }
    return { schema_version: '1.0', rounds: out };
  }

  function validateImportData(data) {
    var errors = [];
    if (!data || typeof data !== 'object' || Array.isArray(data)) return ['Import data must be a single object.'];
    if (Object.keys(data).sort().join(',') !== 'rounds,schema_version') errors.push('Import data must contain only schema_version and rounds.');
    if (data.schema_version !== '1.0') errors.push('schema_version must be the text "1.0".');
    if (!Array.isArray(data.rounds)) { errors.push('rounds must be a list.'); return errors; }
    data.rounds.forEach(function (r, i) {
      var n = 'Round ' + (i + 1) + ': ';
      if (!r || typeof r !== 'object' || Array.isArray(r)) { errors.push(n + 'not an object.'); return; }
      if (Object.keys(r).sort().join(',') !== 'country,course_name,holes_played,round_date,round_total') errors.push(n + 'unexpected fields.');
      if (typeof r.course_name !== 'string' || !r.course_name.trim()) errors.push(n + 'course name missing.');
      if (!isCountry(r.country)) errors.push(n + 'country is not one of the accepted names.');
      if (!isRealDate(r.round_date)) errors.push(n + 'date is not a real YYYY-MM-DD date.');
      if (!isWhole(r.round_total)) errors.push(n + 'score is not a whole number.');
      if (r.holes_played !== 9 && r.holes_played !== 18) errors.push(n + 'holes played is not 9 or 18.');
    });
    return errors;
  }

  function checkFiles(files, limits, existingCount) {
    var accepted = [], rejected = [];
    var room = Math.max(0, limits.maxFiles - (existingCount || 0));
    for (var i = 0; i < files.length; i++) {
      var f = files[i];
      var type = (f.type || '').toLowerCase();
      var name = f.name || 'image';
      var looksHeic = /\.(heic|heif)$/i.test(name);
      if (ACCEPTED_TYPES.indexOf(type) === -1 && !looksHeic) { rejected.push({ name: name, reason: 'Not a supported image. Use JPG, PNG, WebP or HEIC.' }); continue; }
      if (f.size > limits.maxFileBytes) { rejected.push({ name: name, reason: 'Larger than ' + Math.round(limits.maxFileBytes / 1048576) + 'MB.' }); continue; }
      if (accepted.length >= room) { rejected.push({ name: name, reason: 'You can upload up to ' + limits.maxFiles + ' images at a time.' }); continue; }
      accepted.push(f);
    }
    return { accepted: accepted, rejected: rejected };
  }

  function emptyState() {
    return { clubhouseId: '', images: [], rounds: [], discarded: [], questions: [], possibleDuplicates: [], status: '', message: '' };
  }

  function assign(base, patch) {
    var next = {}, k;
    for (k in base) next[k] = base[k];
    for (k in patch) next[k] = patch[k];
    return next;
  }

  /* Merge a result from the server (or the demo) into the working state. A round the user has
     edited is authoritative and is kept as-is; a round the result no longer lists is dropped. */
  function applyResponse(state, result) {
    var byId = {}, gone = {};
    (state.rounds || []).forEach(function (r) { byId[r.id] = r; });
    (state.discarded || []).forEach(function (r) { gone[r.id] = true; });
    var rounds = (result.rounds || []).filter(function (r) { return !gone[r.id]; }).map(function (r) {
      var prev = byId[r.id];
      if (prev && prev.user_edited) return prev;
      return { id: r.id, source_image: r.source_image, course_name: r.course_name, country: isCountry(r.country) ? r.country : null, round_date: r.round_date, round_total: r.round_total, holes_played: r.holes_played, note: r.note || '', user_edited: false };
    });
    return assign(state, {
      rounds: rounds,
      questions: (result.questions || []).filter(function (q) { return !q.round_id || !gone[q.round_id]; }),
      possibleDuplicates: (result.possible_duplicates || []).filter(function (d) { return !(d.round_ids || []).some(function (id) { return gone[id]; }); }),
      status: result.status,
      message: result.message || ''
    });
  }

  function updateRound(state, id, fields) {
    return assign(state, { rounds: state.rounds.map(function (r) {
      if (r.id !== id) return r;
      var next = assign(r, fields);
      next.user_edited = true;
      return next;
    }) });
  }

  /* Drop a round for good: it is remembered so a later check never brings it back, and its
     open questions go with it. */
  function removeRound(state, id) {
    var dropped = state.rounds.filter(function (r) { return r.id === id; });
    return assign(state, {
      rounds: state.rounds.filter(function (r) { return r.id !== id; }),
      discarded: (state.discarded || []).concat(dropped),
      questions: (state.questions || []).filter(function (q) { return q.round_id !== id; }),
      possibleDuplicates: (state.possibleDuplicates || []).filter(function (d) { return (d.round_ids || []).indexOf(id) === -1; })
    });
  }

  /* The body sent to the server. Images go every time (the server keeps nothing). No ClubHouse ID. */
  function buildRequest(state, answers, duplicateDecisions) {
    return {
      images: state.images.map(function (im) { return { id: im.id, name: im.name, media_type: im.mediaType, data: im.base64 }; }),
      rounds: state.rounds.map(function (r) {
        return { id: r.id, source_image: r.source_image, course_name: r.course_name, country: r.country || null, round_date: r.round_date, round_total: r.round_total, holes_played: r.holes_played, user_edited: !!r.user_edited };
      }),
      discarded: (state.discarded || []).map(function (r) {
        return { id: r.id, source_image: r.source_image, course_name: r.course_name, country: r.country || null, round_date: r.round_date, round_total: r.round_total, holes_played: r.holes_played };
      }),
      answers: answers || [],
      duplicate_decisions: duplicateDecisions || []
    };
  }

  /* Sample results used when the section has no endpoint set (Stage 1 review). */
  var DEMO = {
    first: {
      status: 'needs_input',
      message: 'We found three rounds. Two need a little more information before they can be imported.',
      rounds: [
        { id: 'r1', source_image: 1, course_name: 'Royal Birkdale Golf Club', country: 'United Kingdom', round_date: '2025-06-14', round_total: 87, holes_played: 18, note: '' },
        { id: 'r2', source_image: 1, course_name: 'Formby Golf Club', country: 'United Kingdom', round_date: null, round_total: 41, holes_played: null, note: 'Date shows 3 May with no year.' },
        { id: 'r3', source_image: 2, course_name: 'Royal Birkdale Golf Club', country: 'United Kingdom', round_date: '2025-06-14', round_total: 87, holes_played: 18, note: '' }
      ],
      questions: [
        { id: 'q1', round_id: 'r2', source_image: 1, text: 'Image 1, the Formby round: the date reads 3 May but no year is shown. Which year was it?', answer_type: 'year', options: [] },
        { id: 'q2', round_id: 'r2', source_image: 1, text: 'Image 1, the Formby round: was this 9 or 18 holes? The image does not say.', answer_type: 'holes', options: [] },
        { id: 'q3', round_id: 'r2', source_image: 1, text: 'Image 1, the Formby round: the card shows two totals. Which is the gross score?', answer_type: 'score', options: ['41', '38'] }
      ],
      possible_duplicates: [
        { id: 'd1', round_ids: ['r1', 'r3'], text: 'Images 1 and 2 both show Royal Birkdale on 14 Jun 2025 with a score of 87. Are these the same round?' }
      ]
    },
    second: {
      status: 'ready_for_review',
      message: 'All rounds are complete. Check the details below.',
      rounds: [
        { id: 'r1', source_image: 1, course_name: 'Royal Birkdale Golf Club', country: 'United Kingdom', round_date: '2025-06-14', round_total: 87, holes_played: 18, note: '' },
        { id: 'r2', source_image: 1, course_name: 'Formby Golf Club', country: 'United Kingdom', round_date: '2024-05-03', round_total: 41, holes_played: 9, note: '' }
      ],
      questions: [],
      possible_duplicates: []
    }
  };

  return {
    ACCEPTED_TYPES: ACCEPTED_TYPES,
    isRealDate: isRealDate,
    formatDate: formatDate,
    validateRound: validateRound,
    buildImportData: buildImportData,
    validateImportData: validateImportData,
    checkFiles: checkFiles,
    emptyState: emptyState,
    applyResponse: applyResponse,
    updateRound: updateRound,
    removeRound: removeRound,
    buildRequest: buildRequest,
    DEMO: DEMO,
    COUNTRIES: COUNTRIES,
    isCountry: isCountry
  };
}));
